import { FormikHelpers, FormikValues } from 'formik';
import React from 'react';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, { Campo, Botao as BotaoForm } from 'Component/Form';
import Modal from 'Component/Modal';
import Modulo from 'Interface/Modulos';
import { Erro } from 'Interface/Requisicao';
import { useAdicionarModuloMutation } from 'Service';

interface Props {
    exibir: boolean;
    cursoId?: number;
    aoFechar: (estado: boolean) => void;
}

const regras = object({
    nome: string().nullable().required('Obrigatório'),
});

const Adicionar = ({ exibir, aoFechar, cursoId }: Props): React.ReactElement =>
{
    const toast = useToast();
    const [ adicionarModulo ] = useAdicionarModuloMutation();

    const adicinar = async (dados: Modulo, form: FormikHelpers<FormikValues>): Promise<void> =>
    {
        try {
            await adicionarModulo({ ...dados, curso_id: cursoId }).unwrap();

            toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

            aoFechar(false);
        } catch (erro) {
            const { data: errors } = erro as Erro;

            form.setStatus(errors);

            toast({
                titulo: 'Erro ao adicionar',
                conteudo: 'Verifique os logs para maiores detalhes.',
                tema: 'danger',
            });
        }
    }

    return (
        <Modal exibir={ exibir } aoFechar={ aoFechar }>
            <Form onSubmit={ adicinar } regras={ regras }>
                <Campo name="nome" rotulo="Nome do módulo" />

                <div className="mt-5">
                    <BotaoForm>
                        Salvar
                    </BotaoForm>
                    <Botao ms onClick={ () => aoFechar(false) } tema="light">
                        Cancelar
                    </Botao>
                </div>
            </Form>
        </Modal>
    )
}

export default Adicionar;
